module.exports = __webpack_public_path__ + "static/media/2_r_shtora_98.28_0.923e99c7.png";